import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          影迷们正在热议的电影话题，看看大家都在关注什么
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 64;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-sm text-foreground-400 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}